import React, { Component } from "react";

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

class ChunkLoadErrorBoundary extends Component<Props, State> {
  state: State = {
    hasError: false,
  };

  static getDerivedStateFromError(_error: any): State {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: React.ErrorInfo) {
    const errorString = error?.message || error?.toString() || "";
    const isChunkLoadError =
      errorString.includes("Failed to fetch dynamically imported module") ||
      errorString.includes("loading chunk") ||
      errorString.includes("ChunkLoadError") ||
      errorString.includes("Failed to fetch");

    if (isChunkLoadError) {
      const storageKey = "chunk-load-reload-attempted";
      const lastAttempt = localStorage.getItem(storageKey);
      const now = Date.now();

      // If we haven't attempted a reload in the last 10 seconds, reload the page
      if (!lastAttempt || now - parseInt(lastAttempt, 10) > 10000) {
        localStorage.setItem(storageKey, now.toString());
        window.location.reload();
        return;
      }
    }

    console.error("Error caught by ChunkLoadErrorBoundary:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "400px",
            padding: "24px",
            textAlign: "center",
            background: "#fff",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
            margin: "20px",
          }}
        >
          <h3 style={{ color: "#1d3156", marginBottom: "12px" }}>
            Unable to Load Page
          </h3>
          <p
            style={{
              color: "#5d6980",
              fontSize: "14px",
              maxWidth: "400px",
              marginBottom: "20px",
            }}
          >
            We've updated our application. Please reload to get the latest
            version.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              backgroundColor: "#dd4433",
              color: "#fff",
              border: "none",
              padding: "10px 20px",
              borderRadius: "4px",
              cursor: "pointer",
              fontWeight: 500,
              transition: "background-color 0.2s",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = "#b33325")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor = "#dd4433")
            }
          >
            Reload App
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ChunkLoadErrorBoundary;
